import type { LegendSwatchKind } from "@/shared/components/legend-swatch";

/** Textos da HU 2041 (Resolver Conflito de Alocação de Fornecedor). */
export const RESOLVER_TITLE = "Resolver Conflito de Alocação";
export const REMANEJAR_GUIDANCE =
  "Substitua o fornecedor nos escopos macros que causam a sobreposição.";
export const SELECIONAR_CONFLITO_TITLE = "Selecionar Conflito";

export const CLASSIFICACAO_LABEL = "Fornecedor";
export const COMO_RESOLVER_LABEL = "Como deseja resolver?";
export const QUAL_CONFLITO_LABEL = "Qual conflito deseja resolver?";
export const RECOMENDADO_LABEL = "RECOMENDADO";
export const OPCAO_REMANEJAR_TITLE = "Remanejar Fornecedor";
export const OPCAO_REMANEJAR_DESCRIPTION =
  "Substitua o fornecedor em um dos escopos macros de uma obra para eliminar a sobreposição de datas.";
export const OPCAO_IGNORAR_TITLE = "Ignorar Conflito";

export const STEP_ESCOPOS_LABEL = "Escopos";
export const STEP_FORNECEDOR_LABEL = "Fornecedor";
export const DISPONIVEL_LABEL = "Disponível";
export const STEP_REVISAO_LABEL = "Revisão";
export const OBRA_SECTION_LABEL = "1. EM QUAL OBRA O FORNECEDOR SERÁ SUBSTITUÍDO?";
export const ESCOPO_SECTION_LABEL = "2. SELECIONE O ESCOPO MACRO A REMANEJAR";
export const SUBSTITUTO_SECTION_LABEL = "SELECIONE O FORNECEDOR SUBSTITUTO";
export const EM_CONFLITO_LABEL = "Em conflito";
export const SEM_CONFLITO_LABEL = "Sem conflito";
export const GERA_CONFLITO_LABEL = "Gera conflito";
export const IGNORAR_SUBTITLE_PREFIX = "Explique por que o fornecedor pode atender";
export const BUSCAR_FORNECEDOR_PLACEHOLDER = "Buscar Fornecedor";
export const SEM_ALOCACAO_LABEL = "Sem alocação no período";
export const SEM_ALOCACAO_NOTE =
  "“Sem alocação no período” indica que não há alocação registrada no Hub e não confirma a disponibilidade operacional do fornecedor.";
export const ALOCACAO_SECTION_LABEL = "Alocação de cada fornecedor";

/** Mensagens da HU (sucesso, atenção e validação). */
export const REMANEJADO_SUCCESS_MESSAGE = "Fornecedor remanejado. O conflito foi resolvido.";
export const IGNORADO_SUCCESS_MESSAGE = "Conflito marcado como tratado.";
export const INDICADORES_ATUALIZADOS_MESSAGE = "Indicadores do Gantt atualizados.";
export const FORNECEDORES_INDISPONIVEIS_MESSAGE = "Nenhum fornecedor disponível no período.";
export const FORNECEDORES_BUSCA_VAZIA_MESSAGE = "Nenhum fornecedor encontrado para essa busca.";
export const FORMA_REQUIRED_MESSAGE = "Escolha como deseja resolver o conflito.";
export const OBRA_REQUIRED_MESSAGE = "Selecione a obra em que o fornecedor será remanejado.";
export const SUBSTITUTO_REQUIRED_MESSAGE = "Selecione um fornecedor substituto.";
export const JUSTIFICATIVA_REQUIRED_MESSAGE = "Informe a justificativa para confirmar.";

export const FORNECEDORES_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os fornecedores disponíveis. Tente novamente.";
export const CONFLITO_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os dados do conflito. Tente novamente.";

export const JUSTIFICATIVA_MAX_LENGTH = 255;

/** Legenda da revisão: Obra, Cancelada (só com o indicador ligado na tela), Obra Transferida e Hoje. */
export const REVISAO_LEGEND: { key: LegendSwatchKind; label: string }[] = [
  { key: "obra", label: "Obra" },
  { key: "cancelada", label: "Cancelada" },
  { key: "transferida", label: "Obra Transferida" },
  { key: "hoje", label: "Hoje" },
];

export type TratamentoTipo = "remanejar" | "ignorar";
